import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApAmountDisplayComponent } from '@ap/amounts';
import { ApButtonComponent, ApSkipLinkComponent } from '@ap/button';
import { ApContentModule } from '@ap/content';
import { ApHeaderComponent } from '@ap/header';
import { ApIconComponent } from '@ap/icon';
import { SessiebeheerModule } from '@ap/interface-apic-sessiebeheer';
import { provideMijnAuthSessieManager } from '@ap/mijn-auth-sessie-manager';
import { MijnFeedbackModule } from '@ap/mijn-feedback';
import { ApPanelComponent } from '@ap/panel';

import { ConversationalModule } from '../mijn-overzicht-template/conversational/conversational.module';
import { SendableOrdersModalModule } from '../mijn-overzicht-template/sendable-orders-modal/sendable-orders-modal.module';
import { SkeletonModule } from '../mijn-overzicht-template/skeleton/skeleton.module';
import { MijnOverzichtTemplateService } from '../mijn-overzicht-template/mijn-overzicht-template.service';

import { BreadcrumbModule } from './breadcrumb/breadcrumb.module';
import { PegaOverzichtTemplateComponent } from './pega-overzicht-template.component';

/**
 * @name PegaOverzichtTemplateModule
 * @ngdoc module
 */
@NgModule({
    declarations: [PegaOverzichtTemplateComponent],
    imports: [
        ApAmountDisplayComponent,
        ApButtonComponent,
        ApContentModule,
        ApHeaderComponent,
        ApIconComponent,
        ApPanelComponent,
        ApSkipLinkComponent,
        BreadcrumbModule,
        CommonModule,
        ConversationalModule,
        MijnFeedbackModule,
        SendableOrdersModalModule,
        SessiebeheerModule,
        SkeletonModule
    ],
    exports: [PegaOverzichtTemplateComponent],
    providers: [MijnOverzichtTemplateService, provideMijnAuthSessieManager()]
})
export class PegaOverzichtTemplateModule {}
